import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeader, scrollToSection } from "./shared";
import { freelance } from "../../data/portfolioData";

export const FreelanceCTA = () => (
  <section id="freelance" className="py-20 lg:py-28 bg-[#090C13]" data-testid="freelance-cta-section">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl border border-amber-400/20 bg-gradient-to-b from-[#141019] to-[#0B0F19] p-8 sm:p-14 text-center noise-overlay">
          <div className="absolute -top-24 left-1/2 -translate-x-1/2 h-64 w-[480px] rounded-full bg-amber-500/10 blur-[90px]" />
          <p className="relative font-code text-xs sm:text-sm tracking-[0.25em] uppercase text-amber-400/90">
            08 <span className="text-slate-500">/</span> Freelance Collaboration
          </p>
          <h2 className="relative mt-4 font-display text-3xl sm:text-5xl font-bold tracking-tight text-slate-50">
            {freelance.heading}
          </h2>
          <p className="relative mt-5 mx-auto max-w-2xl text-sm sm:text-base text-slate-400 leading-relaxed">
            {freelance.body}
          </p>

          <div className="relative mt-8 flex flex-wrap justify-center gap-2" data-testid="freelance-capabilities">
            {freelance.capabilities.map((c) => (
              <span key={c} className="rounded-full border border-white/10 bg-white/[0.04] px-3.5 py-1.5 text-xs text-slate-300">
                {c}
              </span>
            ))}
          </div>

          <button
            onClick={() => scrollToSection("contact")}
            className="group relative mt-10 inline-flex items-center gap-2 rounded-full bg-amber-400 px-8 py-4 text-sm font-semibold text-[#07090E] transition-all duration-300 hover:bg-amber-300 hover:shadow-[0_0_44px_-8px_rgba(245,158,11,0.75)]"
            data-testid="freelance-cta-button"
          >
            Start a Conversation
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
